<template>
  <div v-if="vx_billInfo">
    <div class="row">
      <div class="col-md-4 col-sm-6">
        <span class="fontSize20 title-color">預約單號：</span>
        <span class="fontSize20">
          {{ vx_billInfo.orderId }}
        </span>
      </div>
      <div class="col-md-8 col-sm-6">
        <span class="fontSize20 title-color">預約時間：</span>
        <span class="fontSize20 text-red">
          {{ formatDate(vx_billInfo.reservationTime) }} ({{
            day(vx_billInfo.reservationTime)
          }})
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-sm-4">
        <span class="fontSize20 title-color">派車方式：</span>
        <span class="fontSize20">{{ method }}</span>
      </div>
      <div class="col-md-6 col-sm-6">
        <span class="current-status fontSize20 text-red">
          目前狀態：{{ result }}
        </span>
        <span class="fontSize20">付款金額：{{ vx_billInfo.actualFare }}</span>
      </div>
    </div>
    <div class="row textareastyle">
      <div class="col-md-12 col-sm-12">
        <span class="fontSize20 title-color">
          上車地點：{{ vx_billInfo.onLocation }}
        </span>
      </div>
    </div>
    <div class="row textareastyle">
      <div class="col-md-12 col-sm-12">
        <span class="fontSize20 title-color">
          上車GPS：{{ vx_billInfo.onGps }}
        </span>
      </div>
    </div>
    <div class="row textareastyle">
      <div class="col-md-12 col-sm-12">
        <span class="fontSize20 title-color">
          下車地點：{{ vx_billInfo.offLocation }}
        </span>
      </div>
    </div>
    <div class="row textareastyle">
      <div class="col-md-12 col-sm-12">
        <span class="fontSize20 title-color">
          下車GPS：{{ vx_billInfo.offGps }}
        </span>
      </div>
    </div>
    <div class="row textareastyle">
      <div class="col-md-12 col-sm-12">
        <span class="fontSize20 title-color">
          實際下車地點：{{ vx_billInfo.actualOffLocation }}
        </span>
      </div>
    </div>
    <div class="row textareastyle">
      <div class="col-md-12 col-sm-12">
        <span class="fontSize20 title-color">
          實際下車GPS：{{ vx_billInfo.finishGps }}
        </span>
      </div>
    </div>
    <div class="row textareastyle">
      <div class="col-md-6 col-sm-6">
        <span class="fontSize20 title-color">
          上車地點備註：{{ vx_billInfo.passengerOnLacatioNote }}
        </span>
      </div>
      <div class="col-md-6 col-sm-6">
        <span class="fontSize20 title-color">
          乘客服務備註：{{ vx_billInfo.passengerNote }}
        </span>
      </div>
    </div>
    <div class="row textareastyle">
      <div class="col-md-7 col-sm-7">
        <span class="fontSize20 title-color">
          服務篩選：{{ serviceNameList }}
        </span>
      </div>
      <div class="col-md-6 col-sm-6">
        <span class="fontSize20 title-color">
          乘客人數：{{ vx_billInfo.seatNumber }} 人
        </span>
      </div>
      <div class="col-md-6 col-sm-6">
        <span class="fontSize20 title-color">取消：</span>
        <span class="fontSize20 title-color text-red">
          {{ cancel }}
        </span>
      </div>
    </div>
    <div class="row textareastyle">
      <div class="col-md-7 col-sm-7">
        <span class="fontSize20 title-color">創建時間：</span>
        <span class="fontSize20 title-color">
          {{ formatDate(vx_billInfo.createTime) }}
        </span>
      </div>
      <button class="btn-primary btn" @click="sendSns">傳訊息給乘客</button>
    </div>
    <div class="row textareastyle">
      <div class="col-md-7 col-sm-7">
        <span class="fontSize20 title-color">乘客上車時間：</span>
        <span class="fontSize20 title-color">
          {{ formatDate(vx_billInfo.pickUpPassengerTime) }}
        </span>
      </div>
    </div>
    <div class="row textareastyle">
      <div class="col-md-7 col-sm-7">
        <span class="fontSize20 title-color">乘客下車時間：</span>
        <span class="fontSize20 title-color">
          {{ formatDate(vx_billInfo.finishTime) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { reqSns } from '@/api/reservation'
import { getDay, getLineUrl } from '@/utils/helper'
import dayjs from 'dayjs'
import { Notification } from 'element-ui'
import { mapState, mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('reservation', {
      vx_fetchOrderDetail: 'fetchOrderDetail',
    }),
    async sendSns() {
      if (
        this.phone.length === 10 &&
        this.phone[0] === '0' &&
        this.phone[1] === '9'
      ) {
        try {
          const { success } = await reqSns({
            phone: this.phone,
            orderId: this.vx_billInfo.orderId,
            url: getLineUrl(),
            task: 'reservation',
          })
          if (success) {
            Notification({
              title: '傳送成功',
              type: 'success',
            })
          } else {
            Notification({
              title: '傳送失敗',
              type: 'error',
            })
          }
        } catch (e) {
          console.error(e)
        }
      } else {
        Notification({
          title: '傳送失敗',
          message: '無乘客電話',
          type: 'error',
        })
      }
    },
    day(val) {
      return getDay(val)
    },
    formatDate(date) {
      if (date) {
        /* server傳至前端的時間為UTC+0，丟入dayjs function將自動轉為local時間(即UTC+8) */
        return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
      }
      return ''
    },
  },
  computed: {
    ...mapState('reserveModal', {
      vx_billInfo: 'billInfo',
      vx_passengerInfo: 'passengerInfo',
      vx_serviceList: 'serviceList',
    }),
    phone() {
      const method = this.vx_billInfo.callMethod
      if (method === 1 || method === 2) {
        return this.vx_billInfo.passengerPhone
      }
      if (method === 0 || method === 3 || method === 4) {
        return this.vx_passengerInfo.passengerPhone
      }
      return this.vx_passengerInfo.phone
    },
    method() {
      switch (this.vx_billInfo.callMethod) {
        case 0:
          return 'APP'
        case 1:
          return '客服'
        case 2:
          return '行政'
        case 3:
          return 'Line'
        case 4:
          return 'FB'
      }
    },
    /* 0: 已配對、1: 已載客、2: 完成 */
    result() {
      if (this.vx_billInfo.passengerCancel) {
        return '乘客取消'
      }
      if (this.vx_billInfo.driverCancel) {
        return '司機取消'
      }
      if (this.vx_billInfo.result === null) {
        return '尚未有司機接單'
      }
      if (this.vx_billInfo.result === 1) {
        return '已載客'
      }
      if (this.vx_billInfo.result === 2) {
        return '完成'
      }
      return '已配對'
    },
    cancel() {
      if (this.vx_billInfo.passengerCancel) {
        return `乘客取消-${this.vx_billInfo.passengerCancel}`
      }
      if (this.vx_billInfo.driverCancel) {
        return `司機取消-${this.vx_billInfo.driverCancel}`
      }
      return '無'
    },
    serviceNameList() {
      if (!this.vx_billInfo.serviceList || this.vx_billInfo.serviceList === '')
        return '無篩選服務'
      const serviceArr = this.vx_billInfo.serviceList.split(',')
      return this.vx_serviceList
        .filter((service) => serviceArr.includes(service.id.toString()))
        .map((service) => service.name)
        .join(',')
    },
  },
}
</script>

<style scoped>
.text-red {
  color: red;
}
.current-status {
  margin-right: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/reserveModal/Mid.vue